"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var TableActionFlag_1 = require("../../../../../../shared/components/table_actions/TableActionFlag");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var BrandsLandingsList = /** @class */ (function (_super) {
    __extends(BrandsLandingsList, _super);
    function BrandsLandingsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 150,
            }, {
                title: 'ID лендинга',
                dataIndex: _this.props.data.dk_landing_identity,
                key: _this.props.data.dk_landing_identity,
                width: 150,
            }, {
                title: 'Номер п/п',
                dataIndex: _this.props.data.dk_order_number,
                key: _this.props.data.dk_order_number,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreActionsDropDownMenu(record), trigger: ['click'] },
                        React.createElement(antd_1.Button, { style: { width: 120, minWidth: 120, maxWidth: 120 } },
                            "\u041D\u043E\u043C\u0435\u0440 ",
                            record.order_number,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 130,
            }, {
                title: 'Image url',
                dataIndex: _this.props.data.dk_cms_image_url,
                key: _this.props.data.dk_cms_image_url,
                width: 150,
            }, {
                title: 'Брэнд',
                dataIndex: _this.props.data.dk_brand_title,
                key: _this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Основная',
                dataIndex: _this.props.data.dk_is_main_page,
                key: _this.props.data.dk_is_main_page,
                align: "center",
                width: 120,
                render: function (text, record, idx) {
                    if (record.is_main_page) {
                        return (React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u0410")));
                    }
                    else {
                        return (React.createElement("div", null, "\u043D\u0435\u0442"));
                    }
                }
            }, {
                title: 'Кол-во стран',
                dataIndex: _this.props.data.dk_countries_count,
                key: _this.props.data.dk_countries_count,
                align: "center",
                width: 120,
                render: function (text, record, idx) {
                    if (record.is_all_country) {
                        return (React.createElement("div", null,
                            React.createElement("b", null, "\u0412\u0421\u0415")));
                    }
                    return (React.createElement("div", null, record.countries_count));
                },
            }, {
                title: 'Устарел',
                dataIndex: _this.props.data.dk_is_deprecated,
                key: _this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 150
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionFlag_1.default, { hint: "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438", onClick: function () { _this.onTranslateClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 110
            }
        ];
        return _this;
    }
    BrandsLandingsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    BrandsLandingsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandsLandingsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    BrandsLandingsList.prototype.doDeprecateAction = function (Key, Title, deprecate) {
        this.props.data.doSetIsDeprecated(Key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041B\u0435\u043D\u0434\u0438\u043D\u0433 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u043C"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041B\u0435\u043D\u0434\u0438\u043D\u0433 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u043C"));
            }
        });
    };
    BrandsLandingsList.prototype.getLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i,
                " \u043D\u043E\u043C\u0435\u0440 "));
        }
        return _ret;
    };
    BrandsLandingsList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } }, this.getLevelsArray()));
    };
    BrandsLandingsList.prototype.doMorection = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.doSetOrderNumber(record.key, _level, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0434\u043B\u044F \u043B\u0435\u043D\u0434\u0438\u043D\u0433\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    BrandsLandingsList.prototype.onTranslateClick = function (record) {
        if (this.props.onTranslateClick) {
            this.props.onTranslateClick(record);
        }
    };
    BrandsLandingsList.prototype.onConfigClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    BrandsLandingsList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandsLandingsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041B\u0435\u043D\u0434\u0438\u043D\u0433 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandsLandingsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    BrandsLandingsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    BrandsLandingsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    BrandsLandingsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                        React.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                flexWrap: "nowrap"
                            } },
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                    " [",
                                    record.key,
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                                    " [",
                                    record.date_added2.format(_this.props.state.getDateTimeFormat()),
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                                    " [",
                                    record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                                    "]")),
                            React.createElement("div", null,
                                React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: "" + _this.props.data.DATA.cdn_baseurl + record.cms_image_url })))));
                }, scroll: { x: true } })));
    };
    return BrandsLandingsList;
}(React.Component));
exports.default = BrandsLandingsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_landings_list/ui/component/BrandsLandingsList.tsx
// module id = 2416
// module chunks = 0